document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.find-vin__form.plate').forEach((form) => {
        form.addEventListener('submit', function (evt) {
            evt.preventDefault();

            const plate = evt.currentTarget.elements['plate'].value.trim();
            const state = evt.currentTarget.elements['state'].value;

            startLoading(form);

            if (!plate.length) {
                showError(form, 'The plate field is required.');
                stopLoading(form);
                return;
            }

            if (!state.length) {
                showError(form, 'The state field is required.');
                stopLoading(form);
                return;
            }

            if (window.onDh ?? 0) {
                stopLoading(form);
                $('#dispute-modal').modal({show: true});
                return;
            }

            const checkRecaptchaLoaded = setInterval(() => {
                if (typeof grecaptcha !== 'undefined' && grecaptcha.execute) {
                    clearInterval(checkRecaptchaLoaded);

                    grecaptcha.ready(() => {
                        grecaptcha.execute(window.recaptchaSiteKeyCode, { action: 'plate' }).then(function (token) {
                            sendAjax(
                                {
                                    plate: plate,
                                    state: state,
                                    recaptcha_response: token,
                                },
                                form
                            );
                        });
                    });
                }
            }, 100);
        });
    });

    function sendAjax(data, form)
    {
        data.type = 'plate';

        fetch('/plate-ajax', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                // jQuery gets this from the ajaxSetup in bootstrap.js; a native fetch does not, and
                // without it /plate-ajax is refused with a 419.
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || '',
            },
            body: JSON.stringify(data),
        })
        .then((response) => response.json())
        .then((res) => {
            stopLoading(form);

            // res.vin is the hash that stands for the VIN, not the VIN (LookupController).
            if (res.vin.length > 0) {
                window.location.href = window.checkOutRoute + '/' + res.vin;
                return;
            }

            showError(form, res.message);
        })
        .catch((error) => {
            stopLoading(form);
            console.error(error);
            showError(form, 'Something went wrong. Please reload the page and try again.');
        });
    }

    function startLoading(form)
    {
        const btn = form.querySelector('.find-vin__plate-btn');
        btn.classList.add('loader');
        btn.disabled = true;
    }

    function stopLoading(form)
    {
        const btn = form.querySelector('.find-vin__plate-btn');
        btn.classList.remove('loader');
        btn.disabled = false;
    }

    function showError(form, message)
    {
        const errorMessage = form.querySelector('.find-vin__error-msg');

        form.classList.add('invalid');
        errorMessage.textContent = message;

        setTimeout(() => {
            form.classList.remove('invalid');
        }, 2000);
    }

    const stateSelects = document.querySelectorAll('.find-vin__field-select');

    stateSelects.forEach(select => {
        select.addEventListener('change', () => {
            const label = select.querySelector('.find-vin__label-select');

            if (select.value !== '') {
                select.classList.add('active');
                label.classList.remove('v-h');
            } else {
                select.classList.remove('active');
                label.classList.add('v-h');
            }
        });
    });
});
